import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../common/header/Header';
import FooterOne from '../common/footer/FooterOne';
import RdsoCertification from '../components/rdso/RdsoCertification';
import { bannerService } from '../services/bannerService';
import { getMediaUrl } from '../services/api';

const RdsoPage = () => {
    const publicUrl = process.env.PUBLIC_URL + '/';
    const [banner, setBanner] = useState(null);

    useEffect(() => {
        bannerService.getPublicBanners('rdso')
            .then(res => {
                if (res.success && res.data && res.data.length > 0) {
                    setBanner(res.data[0]);
                }
            })
            .catch(err => console.error('Error fetching RDSO banner:', err));
    }, []);

    const heading = banner && banner.title ? banner.title : 'RDSO Certificates';
    const bgUrl = banner && banner.image
        ? getMediaUrl(banner.image)
        : `${publicUrl}assets/images/project/new/project24_v1.jpeg`;

    return (
        <>
            <Header />
            <section className="page-header">
                <div 
                    className="page-header__bg" 
                    style={{ backgroundImage: `url(${bgUrl})` }}
                ></div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-header__wrapper">
                                <div className="page-header__content">
                                    <h2>{heading}</h2>
                                    <div className="page-header__menu">
                                        <ul>
                                            <li><Link to={process.env.PUBLIC_URL + `/`}>Home</Link></li>
                                            <li>{heading}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <RdsoCertification />
            <FooterOne />
        </>
    );
};

export default RdsoPage;
